import React from 'react';
import moment from 'moment-timezone';
import ShiftTypeBadge from '../../../features/shifts/ShiftTypeBadge';
import { GLOBAL_CALENDAR_SHIFT_TYPES } from '../../../constants';
import { ReactComponent as InfoIcon } from '../../../assets/images/info-icon-gray.svg';

const FloatShiftDetails = ({ isActionStage, shift, slot, shiftType, unitName }) => {
	const parseResourceAndSpecialtiesString = (resourceCode, specialtiesArray) => {
		if (!resourceCode) return '';
		const specialtiesString =
			specialtiesArray?.length > 0 ? specialtiesArray.map(({ short_name: shortName }) => shortName).join(', ') : '';
		return `${resourceCode}${specialtiesString.length > 0 ? ' - ' : ''}${specialtiesString}`;
	};

	const { caregiver, caregiver_name: caregiverName } = slot;
	const { highest_resource_type: resourceType, specialties } = caregiver || {};

	return (
		<>
			{isActionStage && (
				<div className="info-banner">
					<div className="info-banner__icon">
						<InfoIcon />
					</div>
					<div className="info-banner__text">
						<span>Note:</span> A facility float will move this professional to a shift at a different facility within
						your organization. Once a facility is selected you may also assign the professional to a unit and/or a new
						shift type within that facility.
					</div>
				</div>
			)}

			<div className="shift-data">
				Professional: <b>{caregiverName}</b>
			</div>
			<div className="shift-data">
				License/Specialties: <b>{parseResourceAndSpecialtiesString(resourceType, specialties)}</b>
			</div>

			{isActionStage && (
				<div className="shift-data">
					Current facility: <b>{shift.facility_name}</b>
				</div>
			)}

			<div className="shift-data">
				<span className="shift-detail">
					Shift details: <b>{moment.utc(slot.raw_start_time).format('dddd, MMM DD, YYYY')}</b>
				</span>
				<span className="shift-detail">
					<b>
						{moment.utc(slot.raw_start_time).format('hh:mm A')} – {moment.utc(slot.raw_end_time).format('hh:mm A')}
					</b>
				</span>
				<span className="shift-detail shift-type-badge">
					<ShiftTypeBadge shiftType={GLOBAL_CALENDAR_SHIFT_TYPES.FLEX} />
				</span>
			</div>

			<div className="shift-data">
				<span className="shift-detail">
					Shift type: <b>{shiftType}</b>
				</span>
			</div>

			{isActionStage && (
				<div className="shift-data">
					<span className="shift-detail">
						Unit: <b>{unitName}</b>
					</span>
				</div>
			)}
		</>
	);
};

export default FloatShiftDetails;
